import './actionTag.scss'

export const ActionTag = ({onClick, label, iconUrl}: {onClick?: any, label : string, iconUrl?: string}) => {
    return <span 
        className={'datx-action-tag' }
        onClick={onClick}
    ><img alt={`Icon ${label}`} src={iconUrl}/>{label}</span>
}

